import { AuditSuggestion } from "Models/Audit/AuditSuggestion";
import { AuditTemplate } from "Models/Audit/AuditTemplate";
import { DataState } from "Models/Common/DataState";
import { AuditTemplateFilterState } from "./AuditTemplateFilterState";

export interface IAuditTemplateState {
    suggestions: AuditSuggestion[];
    selectedSuggestion: AuditSuggestion;

    currentFilter: AuditTemplateFilterState;
    auditTemplates: AuditTemplate[];
    totalAudits?: number;
    isLoading: boolean;
    detailAuditTemplates: { [auditTemplateId: number]: AuditTemplate };
    detailAuditTemplateStates: { [auditTemplateId: number]: DataState };
    detailAuditTemplateValidationErrors: { [auditTemplateId: number]: string[] };
}

export class AuditTemplateState implements IAuditTemplateState {
    public suggestions: AuditSuggestion[] = [];
    public selectedSuggestion: AuditSuggestion;

    public currentFilter: AuditTemplateFilterState;
    public auditTemplates: [];
    public isLoading: boolean = false;
    public detailAuditTemplates = {};
    public detailAuditTemplateStates = {};
    public detailAuditTemplateValidationErrors = {};
}


// WEBPACK FOOTER //
// ./src/Store/AuditTemplates/AuditTemplateState.ts